import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

enum ForecastTabs {
  DAY,
  WEEK,
  TEMPERATURE,
  RAIN,
  WIND,
}

@Component({
  selector: 'app-cp-forecast-tabs',
  templateUrl: './cp-forecast-tabs.component.html',
  styleUrl: './cp-forecast-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('animateTab', [
    transition('* <=> *',
      [
        group([
          query(':enter', [
            style({opacity: 0 }),
            animate('.25s ease-in', style({ opacity: 1 }))
          ]),
          query(':leave', [
            style({opacity: 1, position: 'absolute', top: 0, left: 0, right: 0}),
            animate('.25s ease-out', style({ opacity: 0 }))
          ], {optional: true}),
        ])
      ]
    ),
  ])],
})
export class CpForecastTabsComponent {

  selectedTab = signal(ForecastTabs.DAY);

  ForecastTabs = ForecastTabs;

}
